/**
 * 회사정보 재사용 영역
 *
 */
export const CompanyInfo = {
  HOST_NAME_DEFAULT: 'daycomics',
  HOST_NAME_CAMALCASE: 'DayComics',
  EMAIL_CS: 'cs@daycomics.com',
};
